/** 案件历史的“查看此时状态”控件与哈希链验证横幅（第二阶段 P2-1）。 */
export default {
  history: {
    viewAsAt: '查看此时的状态',
    viewAsAtSeq: '查看此时的状态（事件 #{{seq}}）',
    viewingAsAt: '截至事件 #{{seq}}，{{time}}',
    viewingAsAtSeq: '截至事件 #{{seq}}',
    backToCurrent: '返回当前案件',
    chainProven: '已由哈希链证明',
    notChainProven: '未由哈希链证明',
    notChainProvenHint:
      '截至此时的历史记录已无法验证，或此时的部分文件或检查报告在历史记录保存其摘要之前就已记录，或已与摘要不符。',
    stage: '阶段',
    revision: '版本',
    title: '标题',
    documents: '此时的文件',
    submissions: '此时的检查结果',
    none: '无',
    reused: '重复使用',
    loadFailed: '无法加载历史记录中的这一时刻。',
    loading: '正在加载历史记录中的这一时刻…',
  },
  chain: {
    broken: '此提交的历史记录在事件 #{{seq}} 处验证失败（检查于 {{time}}）。未作任何更改。请联系支持人员。',
  },
} as const
